import React from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import {Delete} from "@material-ui/icons";
import HelpToolTip from "../../components/HelpToolTip";
import style from "./style";
import noty from "../../lib/noty";

export default class FieldImage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this._refs = {};
  }

  handleImageChange(event) {
    const imageName = event.target.value.replace(/^.*\\/, "");
    if (event.target.files[0]) {
      const file = event.target.files[0];
      if (file.size >= 10000000) {
        noty.errors("This image is too large. Please upload an image that is less than 10MB.");
        return;
      }
      const reader = new window.FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.props.onChange({
          name: this.props.name,
          value: {
            path: reader.result,
            name: imageName,
            key: this.props.value.key || ""
          }
        });
        // Bc the input is not a controlled input,
        // clear it with each change. Else if you remove an
        // image and try to upload another the event fails.
        this._refs.image.value = "";
      };
      reader.onerror = function(error) {
        console.log("Base 64 Error: ", error);
      };
    }
  }

  handleIconClick() {
    // Trigger a click on the hidden file input to invoke native file upload
    this._refs.image.click();
  }

  clearImage() {
    this.props.onChange({
      name: this.props.name,
      value: {
        path: "",
        name: "",
        key: this.props.value.key || "",
        heading: 0
      }
    });
    this._refs.image.value = "";
  }

  render() {
    return (
      <div>
        <div style={{position: "relative"}}>
          {this.props.tooltip && <HelpToolTip style={{position: "absolute"}} tip={this.props.tooltip} />}
          {this.props.label && (
            <label className="field-label" style={this.props.tooltip ? {paddingLeft: 20} : {}}>
              {this.props.label}
            </label>
          )}
        </div>
        <div style={style.fieldImage}>
          <Button color="secondary" variant="contained" onClick={this.handleIconClick} disabled={this.props.disabled}>
            Choose File
          </Button>
          <div style={style.imageNameText}>{this.props.value.name || "No file chosen (.jpg, .png)"}</div>
          <Tooltip title="Remove Image" placement="right-end">
            <IconButton style={style.rightIcon} onClick={this.clearImage} disabled={this.props.disabled}>
              <Delete style={style.smallIcon} />
            </IconButton>
          </Tooltip>
        </div>
        <input
          onChange={this.handleImageChange}
          type="file"
          ref={ref => {
            this._refs.image = ref;
          }}
          className="hidden"
          accept=".jpg, .jpeg, .png"
        />
      </div>
    );
  }
}

// This component never receives a "value" for the image, only the image name.
// The value prop is for the "imageName"
FieldImage.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/FieldImage/index.jsx